// eslint-disable-next-line no-shadow
export enum LanguageLevel {
  BEGINNER = 'BEGINNER',
  BASIC = 'BASIC',
  INTERMEDIARY = 'INTERMEDIARY',
  ADVANCED = 'ADVANCED',
  PROFICIENT = 'PROFICIENT',
}
